module.exports = __webpack_public_path__ + "img/ic_delete.efe17bea.svg";